"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next_components_icon_n_1 = __importDefault(require("@gerenciatd/next.components.icon-n"));
const next_components_text_info_n_1 = __importDefault(require("@gerenciatd/next.components.text-info-n"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const constants_1 = require("../../constants");
/* ERROR MONITORING */
const File = ({ isGestor, isPriority, title, backLink, segment, titleWithH1Tag, }) => {
    const cssSegment = ` ${segment}`;
    const cssPriority = !isGestor && segment !== constants_1.EMPRESAS && isPriority ? ` ${constants_1.PRIORITY}` : '';
    const forceExternal = true;
    const backLinkToShow = backLink;
    if (!title) {
        return null;
    }
    return (react_1.default.createElement("div", { key: `${title}${backLink}`, className: `File${cssPriority}${cssSegment}` },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "FileContainer" },
                react_1.default.createElement("div", { className: "BackLinkGap" }, backLink && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(next_components_icon_n_1.default, { id: "CheuronLeft", size: 20, className: `backLink${cssPriority}${cssSegment}`, color: "grey4" }),
                    react_1.default.createElement(next_components_custom_link_1.default, { isBlockElement: true, title: "Navegar a nivel anterior", href: backLinkToShow, linkOverBox: true, forceExternal: forceExternal, className: "clbackLink", taggingInfo: {
                            componentname: 'header',
                            componentVariation: 'all',
                            componentProduct: '',
                            componentContent: `back-to-${backLinkToShow}`,
                        } })))),
                react_1.default.createElement("div", { className: "GapBetweenCheuronAndTitle" }),
                react_1.default.createElement("div", { className: "TitleSection" },
                    react_1.default.createElement(next_components_text_info_n_1.default, { color: "green-dark", className: `pageTitle${cssSegment}`, text: title, segment: segment, size: "title02", fontType: "font-light", display: "block", align: "left", kind: !titleWithH1Tag ? 'span' : 'heading' }))))));
};
exports.default = File;
//# sourceMappingURL=index.js.map